import React from 'react';
import { Card } from './ui/card';
import { CheckCircle, Sparkles, Users, Shield, BookOpen, Heart } from 'lucide-react';

const WhyChooseUs = () => {
  const features = [
    {
      icon: Shield,
      title: 'Safe & Secure Campus',
      description: "24/7 CCTV monitoring and secure entry systems ensure your child's safety.",
      color: 'var(--primary-blue)',
    },
    {
      icon: Users,
      title: 'Experienced Teachers',
      description: 'Qualified and caring educators with years of experience in early childhood development.',
      color: 'var(--primary-green)',
    },
    {
      icon: BookOpen,
      title: 'Activity-Based Learning',
      description: 'Hands-on activities, games, and projects that make learning fun and engaging.',
      color: 'var(--primary-red)',
    },
    {
      icon: Sparkles,
      title: 'Modern AC Classrooms',
      description: 'Comfortable, well-ventilated, and bright learning spaces with modern amenities.',
      color: 'var(--primary-orange)',
    },
    {
      icon: Heart,
      title: 'Nurturing Environment',
      description: 'A warm and caring atmosphere where every child feels valued and supported.',
      color: 'var(--primary-yellow)',
    },
    {
      icon: CheckCircle,
      title: 'Legacy of Excellence',
      description: "Backed by HR Hindu High School's 80+ years of trusted educational experience since 1943.",
      color: 'var(--primary-blue)',
    },
  ];

  return (
    <section id="why-us" className="py-20" style={{ backgroundColor: 'white' }}>
      <div className="container mx-auto px-4 lg:px-8">
        <div className="max-w-7xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold heading-playful mb-4" style={{ color: 'var(--primary-green)' }}>
              Why Choose HR KinderNova?
            </h2>
            <p className="text-xl max-w-3xl mx-auto" style={{ color: 'var(--text-secondary)' }}>
              We offer a perfect blend of safety, care, and quality education for your little ones.
            </p>
            <div className="w-24 h-1 mx-auto mt-4 rounded-full" style={{ backgroundColor: 'var(--primary-red)' }}></div>
          </div>

          {/* Features Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
            {features.map((feature, index) => (
              <Card
                key={index}
                className="p-8 rounded-3xl border-0 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
                style={{ backgroundColor: 'var(--surface-cream)' }}
              >
                <div className="w-16 h-16 mx-auto mb-6 rounded-2xl flex items-center justify-center" style={{ backgroundColor: feature.color }}>
                  <feature.icon className="h-8 w-8 text-white" />
                </div>
                <h3 className="text-xl font-bold heading-playful mb-3 text-center" style={{ color: 'var(--text-primary)' }}>
                  {feature.title}
                </h3>
                <p className="text-center" style={{ color: 'var(--text-secondary)' }}>
                  {feature.description}
                </p>
              </Card>
            ))}
          </div>

          {/* Testimonial / Quote Section */}
          <Card className="p-12 rounded-3xl border-0 shadow-2xl" style={{ backgroundColor: 'var(--primary-yellow)' }}>
            <div className="max-w-4xl mx-auto text-center">
              <Sparkles className="h-12 w-12 mx-auto mb-6" style={{ color: 'var(--primary-red)' }} />
              <p className="text-2xl md:text-3xl font-bold heading-playful mb-4" style={{ color: 'var(--text-primary)' }}>
                "Every child is a different kind of flower, and all together make this world a beautiful garden."
              </p>
              <p className="text-lg font-semibold" style={{ color: 'var(--text-secondary)' }}>
                — Our Philosophy at HR KinderNova
              </p>
            </div>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
